import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ProjectReferencePhoto} from 'src/app/models/project-reference-photo';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-select-photos',
    templateUrl: './select-photos.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectPhotosComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectPhotosComponent implements ControlValueAccessor {
    @Input() photos: ProjectReferencePhoto[] = [];

    selectedPhotoIds: number[] = [];

    onChange = (value: number[]) => {};
    onTouched = () => {};

    constructor() {
    }

    writeValue(obj: number[]): void {
        this.selectedPhotoIds = obj;
    }
    registerOnChange(fn: (value: number[]) => void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    toggleSelected(photo: ProjectReferencePhoto) {
        const index = this.selectedPhotoIds.indexOf(photo.id);
        if (index === -1) {
            this.selectedPhotoIds.push(photo.id);
        } else {
            this.selectedPhotoIds.splice(index, 1);
        }

        this.onChange(this.selectedPhotoIds);
        this.onTouched();
    }
}
